import { render, staticRenderFns } from "./copy-forms-list.vue?vue&type=template&id=6d2906be&scoped=true&"
import script from "./copy-forms-list.vue?vue&type=script&lang=js&"
export * from "./copy-forms-list.vue?vue&type=script&lang=js&"
import style0 from "./copy-forms-list.vue?vue&type=style&index=0&id=6d2906be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2906be",
  null
  
)

export default component.exports